export function feature_js_draggable(el, handle) {

        handle = handle ? handle : "modal-header";

        $(el.find(".modal-content").get(0))
            .draggable({
                handle: handle
            });
}